var _defs, _path, _path2, _path3, _path4, _circle, _path5, _circle2, _circle3, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _path6, _path7, _path8, _path9, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _g2, _path10, _text43, _text44, _text45, _text46, _path11, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119, _text120, _text121, _text122, _text123, _text124, _text125, _text126, _text127, _text128, _text129, _text130, _text131, _text132, _text133, _text134, _text135, _text136, _text137, _text138, _text139, _text140, _text141, _text142, _text143, _text144, _text145, _text146, _text147, _text148, _text149, _text150, _text151, _text152, _text153, _text154, _text155, _text156, _text157, _text158, _text159, _text160, _text161, _text162, _text163, _text164, _text165, _text166, _text167, _text168, _text169, _text170, _text171, _text172, _text173, _text174, _text175, _text176, _text177, _text178, _text179, _text180, _text181, _text182, _text183, _text184, _text185, _text186, _text187, _text188, _text189, _text190, _text191, _text192, _text193, _text194, _text195, _text196, _text197, _text198, _text199, _text200, _text201, _text202, _text203, _text204, _text205, _text206, _text207, _text208, _text209, _text210, _text211, _text212, _text213, _text214, _text215, _text216, _text217, _text218, _text219, _text220, _text221, _text222, _text223, _text224, _text225, _text226, _text227, _text228, _text229, _text230, _text231, _text232, _text233, _text234, _text235, _text236, _text237, _text238, _text239, _text240, _text241, _text242, _text243, _text244, _text245, _text246, _text247, _text248, _text249, _text250, _text251, _text252, _text253, _text254, _text255, _text256, _text257, _text258, _text259, _text260, _text261, _text262, _text263, _text264, _text265, _text266, _text267, _text268, _text269, _text270, _text271, _text272, _text273, _text274, _text275, _text276, _text277, _text278, _text279, _text280, _text281, _text282, _text283, _text284, _text285, _text286, _text287, _text288, _text289, _text290, _text291, _text292, _text293, _text294, _text295, _text296, _text297, _text298, _text299, _text300, _text301, _text302, _text303, _text304, _text305, _text306, _text307, _text308, _text309, _text310, _text311, _text312, _text313, _text314, _text315, _text316, _text317, _text318, _text319, _text320, _text321, _text322, _text323, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _text324, _text325, _text326, _text327, _text328, _text329, _text330, _text331, _text332, _text333, _text334, _text335, _text336, _text337, _text338, _text339, _text340, _text341, _text342, _text343, _text344, _text345, _text346, _text347, _text348, _text349, _text350, _text351, _text352, _text353, _text354, _text355, _text356, _text357, _text358, _text359, _text360, _text361, _text362, _text363, _text364, _text365, _text366, _text367, _text368, _text369, _text370, _text371, _text372, _text373, _text374, _text375, _text376, _text377, _text378, _text379, _text380, _text381, _text382, _text383, _text384, _text385, _text386, _text387, _text388, _text389, _text390, _text391, _text392, _text393, _text394, _text395, _text396, _text397, _text398, _text399, _text400, _text401, _text402, _text403, _text404, _text405, _text406, _text407, _text408, _text409, _text410, _text411, _text412, _text413, _text414, _text415, _text416, _text417, _text418, _text419, _text420, _text421, _text422, _text423, _text424, _text425, _text426, _text427, _text428, _text429, _text430, _text431, _text432, _text433, _text434, _text435, _text436, _text437, _text438, _text439, _text440, _text441, _text442, _text443, _text444, _text445, _text446, _text447, _text448, _text449, _text450, _text451, _text452, _text453, _text454, _text455, _text456, _text457, _text458, _text459, _text460, _text461, _text462, _text463, _text464, _text465, _text466, _text467, _text468, _text469, _text470, _text471, _text472, _text473, _text474, _text475, _text476, _text477, _text478, _text479, _text480, _text481, _text482, _text483, _text484, _text485, _text486, _text487, _text488, _text489, _text490, _text491, _text492, _text493, _text494, _text495, _text496, _text497, _text498, _text499, _text500, _text501, _text502, _text503, _text504, _text505, _text506, _text507, _text508, _text509, _text510, _text511, _text512, _text513, _text514, _text515, _text516, _text517, _text518, _text519, _text520, _text521, _text522, _text523, _text524, _text525, _text526, _text527, _text528, _text529, _text530, _text531, _text532, _text533, _text534, _text535, _text536, _text537, _text538, _text539, _text540, _text541, _text542, _text543, _text544, _text545, _text546, _text547, _text548, _text549, _text550, _text551, _text552, _text553, _text554, _text555, _text556, _text557, _text558, _text559, _path21, _text560, _text561, _text562, _text563, _text564, _text565, _text566, _text567, _text568, _text569, _text570, _text571, _text572, _text573, _text574, _text575, _text576, _text577, _text578, _text579, _text580, _text581, _text582, _text583, _text584, _text585, _text586, _text587, _text588, _text589, _text590, _text591, _text592, _text593, _text594, _text595, _text596, _text597, _text598, _text599, _text600, _text601, _text602, _text603, _text604, _text605, _text606;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5FrontDisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2b1a3387-5355-4431-b570-c1a06340dadc",
    "data-name": "Main Disc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crp5_225,.crp5_140,.crp5_131,.crp5_121,.crp5_226,.crp5_142{fill:none}.crp5_134{fill:#fff}.crp5_134,.crp5_131{stroke:#000}.crp5_225,.crp5_134,.crp5_139,.crp5_140,.crp5_131,.crp5_226,.crp5_142{stroke-miterlimit:10}.crp5_134,.crp5_139,.crp5_140,.crp5_226{stroke-width:0.5px}.crp5_139{fill:#a4c9ff}.crp5_139,.crp5_140{stroke:#231f20}.crp5_142{stroke-width:8px}.crp5_142{stroke:#fff}.crp5_164{font-size:10.14px}.crp5_188,.crp5_145,.crp5_198,.crp5_164,.crp5_191,.crp5_186,.crp5_194,.crp5_184,.crp5_196,.crp5_189,.crp5_199,.crp5_195,.crp5_190,.crp5_192,.crp5_193,.crp5_197,.crp5_187,.crp5_185{fill:#231f20}.crp5_188,.crp5_198,.crp5_164,.crp5_191,.crp5_186,.crp5_194,.crp5_184,.crp5_217,.crp5_232,.crp5_196,.crp5_189,.crp5_199,.crp5_195,.crp5_190,.crp5_192,.crp5_193,.crp5_197,.crp5_230,.crp5_221,.crp5_187,.crp5_185,.crp5_204{font-family:HelveticaNeue-Condensed, Helvetica Neue}.crp5_184{font-size:10.14px}.crp5_185{font-size:10.14px}.crp5_186{font-size:10.14px}.crp5_187{font-size:10.14px}.crp5_188{font-size:9.75px}.crp5_189{font-size:9.75px}.crp5_190{font-size:9.75px}.crp5_191{font-size:9.75px}.crp5_192{font-size:9.75px}.crp5_193{font-size:9.75px}.crp5_194{font-size:9.75px}.crp5_195{font-size:9.75px}.crp5_196{font-size:9.75px}.crp5_197{font-size:6.35px}.crp5_198{font-size:6.35px}.crp5_199{font-size:6.35px}.crp5_200{fill:url(#4334364d-d7d1-4f73-b48f-d10c54ce00e7)}.crp5_224,.crp5_210,.crp5_214,.crp5_204{font-size:9px}.crp5_210,.crp5_220,.crp5_219{fill:#3e86c5}.crp5_224,.crp5_218,.crp5_210,.crp5_222,.crp5_223,.crp5_220,.crp5_214,.crp5_219,.crp5_233{font-family:HelveticaNeue-Roman, Helvetica Neue}.crp5_217,.crp5_218,.crp5_219{font-size:8px}.crp5_220{font-size:8.43px}.crp5_221{font-size:10px}.crp5_222{font-size:7px}.crp5_223{font-size:6.47px}.crp5_224{text-decoration:underline}.crp5_225,.crp5_226{stroke:#840000}.crp5_232,.crp5_230,.crp5_233{fill:#840000}.crp5_230{font-size:6px}.crp5_231{letter-spacing:0.05em}.crp5_232,.crp5_233{font-size:5.5px}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "00ddbe55-0b28-4602-920b-508d61ad67d0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "crp5_121",
    cx: 297.6,
    cy: 420.48,
    r: 160.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "afdc7dfb-03c5-4216-9e97-2ba7ad5e7b19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "crp5_121",
    d: "M218.22 373.36a92.31 92.31 0 1 0 126.5-32.25 92.32 92.32 0 0 0-126.5 32.25M207.5 367a104.78 104.78 0 1 1 36.61 143.59A104.78 104.78 0 0 1 207.5 367m-20.92-12.42a129.12 129.12 0 1 0 176.94-45.11 129.12 129.12 0 0 0-176.94 45.11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "4334364d-d7d1-4f73-b48f-d10c54ce00e7",
    cx: 2.65,
    cy: 839.28,
    r: 1,
    gradientTransform: "matrix(7.12, 4.23, 4.23, -7.12, -3274.51, 6386.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "crp5_134",
    d: "M435.89 502.59a160.83 160.83 0 1 1-56.19-220.4 160.83 160.83 0 0 1 56.19 220.4M192.6 359.08a95.66 95.66 0 0 0-8 16.75l11.4 4.61a106.76 106.76 0 0 1 7.3-15c5-8.65 8.16-11.85 8.16-11.85l-9.9-7.59a101 101 0 0 0-9 13.12m125.64-24.15l-2.46 11a75.84 75.84 0 0 1 25.86 11.84 79 79 0 0 1 19.3 19.56l9.4-6.39a84.85 84.85 0 0 0-22-22.41 90.19 90.19 0 0 0-30.12-13.6m83.91 92l-12.4-.75s-.53 17.59-8.94 34.34C371.54 479 360.6 488 360.6 488l8.35 9.19S382 486.29 392 465.9a99.9 99.9 0 0 0 10.12-39m-145.66 38.57l-8.08 8.84a65.26 65.26 0 0 0 13.37 9.69 67.59 67.59 0 0 0 15.65 6.6l3.35-11.6a56.77 56.77 0 0 1-12.24-5 80.32 80.32 0 0 1-12.05-8.49m47.21-41.38a7.06 7.06 0 1 0-9.68 2.46 7.07 7.07 0 0 0 9.68-2.46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_139",
    d: "M307.58 521.72l2.95 28.28s-66 10.46-117.23-51.57c-38.41-46.55-22.23-110.15-22.23-110.15l27.79 7.58s-11.06 35.64 9.4 73.32c3.48-1.81 5.1-2.7 5.1-2.7a80.83 80.83 0 0 0 9.6 14.39 63 63 0 0 0 11.38 10.9l-4.34 4.72s28.15 30.15 77.58 25.23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442 419.72a144.41 144.41 0 1 1-145.16-143.64A144.4 144.4 0 0 1 442 419.72M296.92 291.37a129.12 129.12 0 1 0 129.8 128.43 129.12 129.12 0 0 0-129.8-128.43",
    fill: "#ffde17",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_140",
    d: "M392.82 300.7l-11.9 15m38.46 12.12l-15.23 11.58m39 34L425 379.23m24.69 24.53l-19 2.06m14.8 53.49l-18.5-4.92m10 28.7l-17.43-7.9m-7.22 46L398 508.51m-.83 27.59l-12.43-14.54m-20.32 35.94L356 540.22m-8.93 24.3L341 546.41m-27.58 25.45l-1.92-19m-14.6 19.77l.14-19.14m-31 15.74l4-18.71m-18.16 15l5.8-18.23m-30.92 7.7l8.93-16.99m-10.33-6l-10.43 16m-20-15.47l12.94-14.1m-21.8 5.28l14-13m-12.83-16.23l-15.89 10.66m-5.62-9l16.59-9.54m-26.17-10.35l17.8-7M171.1 461l-18.22 5.86M148.12 448l18.82-3.5m-20.28-6.1l19-2.29m-20.1-16.17h19.14m-18.87-8.8l19.1 1.12m-17.13-18.14l18.85 3.27m-17.13-11.74l18.64 4.35m-14.31-19.42l18.1 6.22m-15.31-13.7l17.75 7.17m5.78-12.45l-16.91-8.95m19.92 3.57l-16.48-9.74m7.8-11.91L190 342m-11.16-16.93l15 11.93m25.35-24.35l-11.31-15.43m52.87-24.91l4.69 18.56m46.8-22.54l-1.77 19.06m47-7.67L350 297.34"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297.6,
    cy: 420.48,
    r: 136.06,
    strokeWidth: 8,
    stroke: "#ffde17",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_140",
    d: "M375.65 289.69l-9.78 16.45m41.05 8.18l-13.7 13.36M429 343.21l-16.47 9.73m18.08 78.81l19.07 1.58m-24.12 70.54l-16.05-10.43m-28.59 55.1l-10.44-16M330 569.79l-4-18.71m-45.2 21.21l2.12-19m-44.46 8l7.44-17.63m-41.68-2.41L216 526.08m-37.77-10.67l15-11.88m-32.83-16.6l17.24-8.3m-9.13-25.11l-18.55 4.7m-4.43-28.89l19.11-1.08m-18.35-25l19 2.19m-14.08-26.82l18.39 5.28m-10.11-27.45l17.35 8.06m9.32-16.76l-16-10.48m13-17.14l14.38 12.62m35.84-50.26l8.08 17.35m45.47-31.21l1.35 19.08m47.34-14.69l-4.76 18.53m43.87-.33l-8.85 14.88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "crp5_142",
    cx: 297.6,
    cy: 420.48,
    r: 148.82
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.6,
    cy: 420.48,
    r: 135.35,
    strokeWidth: 6,
    stroke: "#ffde17",
    strokeMiterlimit: 10,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00ddbe55-0b28-4602-920b-508d61ad67d0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "crp5_140",
    d: "M389.09 275.54l-10.51 16.65m3.42 2.23l11-16.36m3.8 2.61l-11.4 16.06m15.12-13.34l-11.82 15.75M407.5 289l-12.62 15.11m15.94-12.27l-13 14.79m16.25-11.86l-13.38 14.45m16.55-11.44l-13.75 14.1m19.72-8l-14.43 13.4M426 307l-14.76 13m17.49-9.87l-15.07 12.68m17.73-9.44L416 325.68m20.35-5.78l-15.95 11.55m18.26-8.28l-16.21 11.18m18.45-7.85l-16.47 10.8m18.63-7.42l-16.72 10.4m20.71-3.66l-17.18 9.64m19.13-6.12l-17.39 9.23m19.23-5.67l-17.6 8.82m19.22-5.52l-17.8 8.43m20.81-1.72l-18.14 7.67m19.57-4.18l-18.31 7.27m19.66-3.75l-18.46 6.86m19.73-3.31l-18.6 6.45m20.88.6L442.93 377m19.88-2.15l-19 5.25m19.92-1.73l-19.09 4.84m19.94-1.3l-19.18 4.43m20.6 2.42l-19.35 3.64m19.94-.33l-19.42 3.26m19.94.06l-19.48 2.88m19.94.45l-19.53 2.5m.64 5.88l19.61-1.73M448.94 410l19.64-1.35M449.11 413l19.67-1m.13 3.32l-19.68.6m.06 5.77l19.69.15m-.05 3.2l-19.69-.52m19.58 3.72l-19.68-.89m19.5 4.09L449 430.17m18.81 10.49l-19.56-2.31m18.75 8.33l-19.46-3m18.42 9L446.6 449m-1.1 5.26l19.2 4.38m-3 11.36l-18.85-5.68M460 475.39l-18.65-6.31m16.74 11.66l-18.43-6.92M456 486l-18.19-7.53m13.73 17.43l-17.68-8.67m-2.08 4.08l17.41 9.2m-19.61-5.18l17.13 9.72m-2.71 4.49l-16.82-10.23m11.25 18.81l-16.19-11.21m13.25 15.32l-15.85-11.69m12.79 15.72L417 514.11m12.32 16.08l-15.13-12.6m8.62 20l-14.39-13.45M419.46 541l-14-13.85m10.59 17.21l-13.61-14.24m10.1 17.49L399.34 533m6.18 20.62l-12.4-15.3m8.9 18.06L390 540.8m-3.16 2.36l11.59 15.92m-3.64 2.57l-11.17-16.21m3.78 21l-10.3-16.74m6.58 19l-9.89-17m6.09 19.17l-9.45-17.27m5.57 19.3l-9-17.51m1.31 21.23l-8.13-17.94m4.29 19.63l-7.69-18.13m3.8 19.72l-7.24-18.32m-3.47 1.33l6.79 18.48M349 584l-5.91-18.78m2.16 19.91l-5.48-18.91m1.7 20l-5-19m1.24 20L333.07 568m-6.73 1.46l3.74 19.33M323 570.07l3.3 19.42m-3.81.6l-2.86-19.48m-1 20l-2.42-19.55m-6.66.68l1.55 19.64m-3.7.25L306.28 572m-3.28.15l.71 19.68m-4-19.6l.28 19.69m-7.27 0l.55-19.68m-4.11 19.54l1-19.67m-4.51 19.46l1.35-19.73m-4.92 19.36l1.78-19.61m-8.74 18.84l2.58-19.52m-6 19l3-19.46m-6.36 18.91l3.36-19.4m-6.75 18.78l3.75-19.33m-10.33 17.92l4.51-19.17m-7.7 18.38L260 567.5m-8 18.23l5.23-19m-8.4 18.08l5.6-18.89m-11.73 16.94l6.3-18.64m-9.28 17.63l6.65-18.54m-9.59 17.45l7-18.41m-2.59-1l-7.32 18.28m-1.29-22l-8.44 17.79m-13.41-7.1l10-17m-22.47 8.89l11.42-16M187 551.46l12.71-15.05m-23.1 5.59l13.9-14m-8.19-8.83l-15 12.81m-8.26-10.44L175 509.93M152 511l16.73-10.4m-22.79-.17l17.42-9.19m-4.77-9.9l-18 7.9m-4.37-11l18.54-6.64m-3-9.26l-18.93 5.44m-2.68-10.58l19.22-4.2m-21.25-6.59l19.47-3m-20.77-7.87l19.61-1.73m-20.21-8.64l19.68-.54m-19.67-9.33l19.68.59m-19.11-10.3l19.62 1.71M127.91 396l19.49 2.82m-17.84-12.39l19.31 3.91m-17.22-12.95l19.06 4.95m2.16-7.51l-18.78-5.92m2.9-8.42l18.44 6.89m-15.12-15.14l18.07 7.84m3.29-7.09L144 344.26m3.91-7.41l17.19 9.61m3.57-6L152 330m4.38-6.7l16.22 11.16m-11.49-17.7l15.68 11.91m-10.64-18.23l15.1 12.64m-7.43-21.19L188 315.53m-9-18.89l13.62 14.23m-8.12-19.26l13 14.8m-7.28-19.59l12.33 15.36m-.89-23.79l11 16.33m-5.33-20l10.36 16.75m-4.54-20.19l9.69 17.14m5.26-2.84l-9-17.51m12-5.6l7.64 18.16m-1.63-20.55l6.94 18.43m-.85-20.59l6.24 18.67m-.07-20.59l5.54 18.9m10.73-2.72l-4.15-19.25m5.93-1.17l3.46 19.39m2.51-20.35l2.78 19.5m3.21-20.3l2.09 19.59m9.53-20.4l.75 19.68m5-.11l-.11-19.69m5.09 19.75l.54-19.69m5.61.25L306.7 269m12.18-18.63l-2.45 19.54m7.81-18.79l-3.06 19.46m8.39-18.53l-3.67 19.35m9-18.25l-4.29 19.22m14.49-16.62l-5.46 18.92m10.36-17.4L344 276m10.87-17.11l-6.58 18.56m11.37-16.78l-7.12 18.36m16.14-14.56l-8.17 17.92m12.39-15.93l-8.65 17.69M377 268.59L367.89 286m13.23-15.23l-9.6 17.23"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "crp5_142",
    cx: 297.6,
    cy: 420.48,
    r: 153.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "crp5_140",
    d: "M375.13 289.84l11.13-18.72m19.18 13.23l-13.53 17m29.93-2.25l-15.59 15.2m29.42.84l-17.33 13.19M447 332l-18.75 11.07m7.75 15.07l19.86-8.92m6.84 17.8L442 373.7m25.43 11.11l-21.31 4.45m24 12.35L448.45 404m22.65 14.43l-21.78.24m21.2 15.95l-21.71-1.8m16.48 32l-21.05-5.58m11.39 32.65l-19.83-9m7.26 31.94L424.81 503m-13.53 17.79l16.31 14.42m-17.26 17l-14.14-16.61m-3.91 30.06l-11.88-18.25m-7.33 29.09l-9.48-19.61m-10.16 27.65l-7-20.62m-12.1 25.91l-4.61-21.28m-16.86 2.67l2.19 21.67m-18.75.87l.17-21.77m-18.15 20.7l2.42-21.64m-15-2.45l-4.57 21.29m-9.5-25l-6.59 20.76m-14.91-5.5l8.47-20.07m-22.15 13.58l10.18-19.25M203 565.73l11.87-18.26m-23.71 9.83l13.36-17.2m-24.23 8l14.72-16m-24.8 6l16-14.79M161.58 528l17.07-13.51m-25.1 2.51l18.07-12.14m-24.47 1.85L166 495.83m-5.12-9.72l-19.62 9.45m-5-11.51l20.25-8m-24.07-2.68l20.73-6.66m-23.74-3.81l21.11-5.35M127 451.94l21.41-4m-23.08-7l21.67-2.53m-.85-9.62L124.38 430m-.28-10h21.78m.26-8.73L124.4 410m.85-9.65l21.62 2.5m-20.22-12.24l21.45 3.72m1.71-8.43L128.6 381m2.25-8.64l20.92 6m-18.24-14.54l20.6 7.09m-17.42-15.59l20.19 8.14m3.11-7.16l-19.74-9.18m4-8l19.25 10.18m-15.34-17.18l18.76 11.06m-14.52-17.88l18.22 11.92m4.06-5.89L157 318.58m4.95-6.51l17 13.58m4.59-5.49l-16.32-14.36m40.62-7.86L195 280.38m29.4-17.4l9.19 19.74M255.13 252l5.33 21.11m24.83-25.95l1.54 21.72m26.89-21.41l-2 21.68m29-17l-5.41 21.09m29.92-12.82l-8.48 20m28.48-7.61l-10.07 16.93"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "crp5_142",
    cx: 297.6,
    cy: 420.48,
    r: 150.94
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "crp5_164",
    transform: "matrix(0.97, 0.25, -0.25, 0.97, 321.53, 292.28)"
  }, "1:30")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_184",
    transform: "translate(279.79 291.17) rotate(-4.07)"
  }, "1:20")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_164",
    transform: "translate(234.79 306.01) rotate(-24.97)"
  }, "1:10")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_184",
    transform: "matrix(0.67, -0.75, 0.75, 0.67, 193.87, 341.08)"
  }, "1:00")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_185",
    transform: "translate(175.78 373.25) rotate(-65.07)"
  }, "9:00")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_186",
    transform: "translate(167.16 413.9) rotate(-83.42)"
  }, "8:00")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(173.26 460.84) rotate(-104.22)",
    fontSize: 10.14,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "7:00")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.62, -0.78, 0.78, -0.62, 200.57, 508.08)",
    fontSize: 10.14,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "6:00")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(254.7 543.8) rotate(-157.12)",
    fontSize: 10.14,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "5:00")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_187",
    transform: "translate(291.54 550.97) rotate(-173.62)"
  }, "4:30")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(333.38 545.98) rotate(167.78)",
    fontSize: 10.14,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "4:00")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_185",
    transform: "matrix(-0.84, 0.55, -0.55, -0.84, 375.72, 524.86)"
  }, "3:30")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_187",
    transform: "matrix(-0.55, 0.84, -0.84, -0.55, 411.47, 484.45)"
  }, "3:00")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_187",
    transform: "translate(428.06 422.86) rotate(94.73)"
  }, "2:30")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_187",
    transform: "matrix(0.51, 0.86, -0.86, 0.51, 405.39, 346.96)"
  }, "2:00")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(384.97 323.48) rotate(45.73)",
    fontSize: 10.14,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "1:50")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(356.76 304.33) rotate(30.73)",
    fontSize: 10.14,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "1:40")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_145",
    d: "M423.78 386.51c-.08-.3-.12-.45-.21-.76l2.95-.83c-.24-.87-.37-1.3-.63-2.16l-2.93.89c-.1-.3-.14-.45-.23-.75l6.08-1.89c.1.32.14.48.24.8l-2.49.75c.26.86.39 1.3.63 2.17l2.51-.71.22.8zM428.12 390.69c-1.56.37-3.28.46-3.7-1.25s1.13-2.42 2.68-2.84 3.29-.56 3.74 1.25-1.15 2.48-2.72 2.84m-.8-3.27c-1.43.37-2.54.8-2.27 1.87s1.45.92 2.88.58 2.57-.76 2.29-1.87-1.48-.95-2.9-.58M431.43 390.88l.18.8-4.38.95c-.91.2-1.27.59-1.12 1.35s.69 1 1.57.81l4.39-.87c.06.33.1.49.16.82l-4.4.83a1.79 1.79 0 0 1-2.35-1.46c-.25-1.25.3-2 1.58-2.26l4.37-1M432.41 395.73c.16.86.23 1.29.37 2.14a1.51 1.51 0 0 1-1.31 1.94 1.48 1.48 0 0 1-1.74-.75 1.05 1.05 0 0 1-.91 1.07l-1.07.22c-.69.14-.85.28-.93.48l-.15-.93a2 2 0 0 1 .88-.36l1-.21c.86-.19.83-.69.77-1.1s-.11-.64-.19-1.07l-2.79.49c-.06-.31-.08-.47-.14-.77l6.26-1.15m-2.7 1.32c.06.31.08.47.14.79.08.47.22 1.33 1.43 1.14.62-.1.94-.59.81-1.35-.06-.39-.09-.58-.16-1l-2.22.39M431.93 403.58c.67-.08 1.1-.39 1-1.17a1 1 0 0 0-1.17-1c-1.78.25-.33 3.19-2.64 3.45a1.81 1.81 0 0 1-2.12-1.76c-.19-1.48.5-2 1.84-2.21 0 .31.07.47.11.79-.71.1-1.46.25-1.31 1.4a1.08 1.08 0 0 0 1.25 1c1.79-.22.36-3.14 2.67-3.47a1.68 1.68 0 0 1 2 1.7 1.6 1.6 0 0 1-1.53 2.07l-.1-.81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.08 325.13l-2.4 2.93s-1.32-6.2-10.07-13.89l12.47 11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.74 325.51l2.94-3.13s-6.32-.52-15.06-8.21c8.57 7.54 12.12 11.34 12.12 11.34"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_145",
    transform: "translate(-68.17 464.17) rotate(-59.26)",
    d: "M368.76 285.94h10.41v12.15h-10.41z"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(368.25 292.7) rotate(30.73)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#fff"
  }, "10")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_189",
    transform: "matrix(0.97, 0.25, -0.25, 0.97, 329.32, 277.93)"
  }, "90")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(282.71 275.12) rotate(-4.07)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "80")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_190",
    transform: "translate(231.83 290.16) rotate(-24.97)"
  }, "70")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(166.41 356.3) rotate(-62.12)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "55")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_191",
    transform: "translate(154.44 392) rotate(-76.92)"
  }, "50")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(152.27 433.31) rotate(-93.22)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "45")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_192",
    transform: "translate(163.68 478.39) rotate(-111.57)"
  }, "40")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(193.67 523.02) rotate(-132.77)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "35")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(245.16 556.75) rotate(-157.12)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "30")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_191",
    transform: "matrix(-0.99, 0.1, -0.1, -0.99, 317.05, 565.07)"
  }, "25")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(333.12 562.09) rotate(167.78)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "24")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_193",
    transform: "translate(349.12 557.14) rotate(161.23)"
  }, "23")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_194",
    transform: "translate(365.48 549.82) rotate(154.22)"
  }, "22")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_191",
    transform: "matrix(-0.84, 0.55, -0.55, -0.84, 381.29, 540.08)"
  }, "21")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_188",
    transform: "matrix(-0.76, 0.65, -0.65, -0.76, 396.04, 528.37)"
  }, "20")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_192",
    transform: "translate(410.07 513.64) rotate(131.48)"
  }, "19")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.55, 0.84, -0.84, -0.55, 422.58, 496.11)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "18")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_195",
    transform: "translate(432.5 476.26) rotate(114.38)"
  }, "17")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_196",
    transform: "translate(439.99 453.37) rotate(104.88)"
  }, "16")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(443.58 427.84) rotate(94.73)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "15")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(442.26 400.04) rotate(83.83)",
    fontSize: 9.75,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "14")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_195",
    transform: "translate(435.09 371.11) rotate(72.13)"
  }, "13")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_194",
    transform: "translate(421.05 342.26) rotate(59.43)"
  }, "12")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(399.17 315.12) rotate(45.73)",
    fontSize: 9.77,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "11")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#afdc7dfb-03c5-4216-9e97-2ba7ad5e7b19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "crp5_140",
    d: "M383.96 427.87l24.4 2.1M383.53 431.79l24.29 3.19M382.92 435.75l24.11 4.31M382.09 439.82l23.87 5.47M381.12 443.63l23.61 6.55M379.94 447.55l23.27 7.64M378.41 451.82l22.84 8.86M376.69 455.93l22.36 10.02M374.59 460.29l21.76 11.26M372.36 464.33l21.13 12.4M369.38 469.07l20.28 13.73M366.41 473.18l19.45 14.89M364.4 469.45l24.96 18.3M362.82 477.57l18.43 16.13M358.52 482.13l17.22 17.43M386.12 430.01l19.23 2.07M385.59 434.09l19.11 2.96M384.85 438.22l18.95 3.86M383.92 442.31l18.74 4.75M382.84 446.21l18.51 5.58M381.43 450.49l18.2 6.51M379.77 454.76l17.84 7.44M377.83 459.08l17.42 8.39M375.59 463.43l16.93 9.33M372.95 467.92l16.36 10.3M369.86 472.49l15.7 11.3M366.46 476.93l14.95 12.26M362.4 481.54l14.08 13.26"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_140",
    d: "M359.53 375.16l-3 2.19m2.11-3.37l-2.95 2.25m2-3.42l-2.9 2.31m2-3.46L354 374m1.9-3.5l-2.9 2.44m1.83-3.54l-2.76 2.47m1.76-3.57l-2.71 2.53m1.69-3.61l-2.67 2.58m1.64-3.63l-2.62 2.63m1.57-3.66l-2.57 2.68m1.49-3.69l-2.51 2.72m1.42-3.71l-2.46 2.77m.11-4.78L343.9 364m1.09-3.88L342.7 363m1-3.91l-2.22 3m.91-3.93l-2.16 3m-.51-4.85l-2 3.11m.67-4l-2 3.14m.59-4l-1.9 3.19m.5-4l-1.83 3.25m-1.15-4.84l-1.69 3.31m.1-4.1l-1.61 3.35m0-4.1l-1.52 3.38m-.08-4.09l-1.46 3.41m-1.83-4.73l-1.29 3.48m-.37-4.08l-1.21 3.51M320 351l1.13-3.53m-1.68-.52l-1.06 3.55m-2 1.11l1.48-5.23m16.24 6.56l-2.65 4.84m16 4.36l-3.6 4.19m13.87 6.49l-4.32 3.43m-29.29-21.92l2.09-5.12m14.82 8l-3.14 4.55m14.95 5.47l-4 3.83"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_197",
    transform: "matrix(0.96, 0.27, -0.27, 0.96, 312.13, 355.63)"
  }, "30")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_198",
    transform: "matrix(0.88, 0.48, -0.48, 0.88, 326.36, 360.75)"
  }, "20")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_199",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 338.25, 368.31)"
  }, "10")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.62, 0.78, -0.78, 0.62, 348.46, 378.36)",
    fontSize: 6.35,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#231f20"
  }, "0")), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_200",
    d: "M303.43 423.94l.85.52a7.77 7.77 0 0 1-10.65 2.71l.54-.84-.52.86a7.79 7.79 0 0 1-2.71-10.66l.83.55-.86-.51a7.79 7.79 0 0 1 10.66-2.72l-.45.76.41-.78-.45.76.41-.78a7.77 7.77 0 0 1 2.71 10.65l-.82-.48.85.42v.06l-.82-.48.85.42-.85-.52-.9-.43v-.08a5.78 5.78 0 0 0-2-7.92l.52-.85-.48.88a5.78 5.78 0 0 0-7.92 2l-.77-.5.79.46-.77-.5.79.46a5.77 5.77 0 0 0 2 7.92l-.45.7.43-.72-.45.7.43-.72a5.78 5.78 0 0 0 7.92-2l.86.5-.9-.43z"
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(306.18 373.21) rotate(12.82)"
  }, "A")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(311.81 374.52) rotate(19.36)"
  }, "L")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(315.74 375.85) rotate(24.5)"
  }, "T")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(0.87, 0.49, -0.49, 0.87, 320.4, 378.04)"
  }, "I")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(0.83, 0.55, -0.55, 0.83, 322.44, 379.1)"
  }, "T")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 326.72, 381.88)"
  }, "U")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(0.67, 0.74, -0.74, 0.67, 331.59, 386.04)"
  }, "D")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(335.75 390.71) rotate(55.1)"
  }, "E")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(0.5, 0.87, -0.87, 0.5, 338.83, 395.22)"
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(345.69 423.63) rotate(95.82)"
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.75, 0.66, -0.66, -0.75, 330.87, 454.56)"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(328.99 456.24) rotate(141.37)"
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.81, 0.58, -0.58, -0.81, 327.01, 457.81)"
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.84, 0.54, -0.54, -0.84, 324.95, 459.29)"
  })), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.87, 0.49, -0.49, -0.87, 322.82, 460.65)"
  })), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(320.62 461.89) rotate(153.6)"
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.92, 0.4, -0.4, -0.92, 318.35, 463.02)"
  })), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.94, 0.35, -0.35, -0.94, 316.03, 464.02)"
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.96, 0.3, -0.3, -0.96, 313.68, 464.88)"
  })), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(311.27 465.63) rotate(165.88)"
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "matrix(-0.99, 0.16, -0.16, -0.99, 308.87, 466.3)"
  }, "D")), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(303.39 467.17) rotate(177.05)"
  }, "E")), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(298.58 467.44) rotate(-176.69)"
  }, "N")), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(292.89 467.1) rotate(-170.16)"
  }, "S")), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(287.83 466.17) rotate(-165.79)"
  }, "I")), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "matrix(-0.95, -0.31, 0.31, -0.95, 285.82, 465.71)"
  }, "T")), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(281.49 464.3) rotate(-155.84)"
  }, "Y")), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(276.83 462.14) rotate(-151.4)"
  })), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "matrix(-0.85, -0.52, 0.52, -0.85, 274.66, 460.96)"
  })), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(272.56 459.72) rotate(-143.68)"
  }, "A")), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(268.43 456.67) rotate(-137.95)"
  }, "L")), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(265.67 454.22) rotate(-133.42)"
  }, "T")), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "matrix(-0.64, -0.77, 0.77, -0.64, 262.56, 450.88)"
  }, "I")), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "matrix(-0.58, -0.81, 0.81, -0.58, 261.22, 449.32)"
  }, "T")), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(258.57 445.65) rotate(-119.27)"
  }, "U")), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(255.78 440.68) rotate(-112.44)"
  }, "D")), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_219",
    transform: "translate(253.67 435.54) rotate(-106.12)"
  }, "E")), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(217.03 399.39) rotate(-72.24)"
  }, "C")), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(218.73 394) rotate(-68.22)"
  }, "O")), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(220.91 388.45) rotate(-63.76)"
  }, "M")), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(223.96 382.3) rotate(-59.66)"
  }, "P")), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "matrix(0.53, -0.85, 0.85, 0.53, 225.77, 379.19)"
  }, ".")), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(226.8 377.52) rotate(-56.91)"
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(227.82 375.86) rotate(-54.29)"
  }, "C")), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "matrix(0.64, -0.77, 0.77, 0.64, 231.1, 371.27)"
  }, "O")), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "matrix(0.69, -0.72, 0.72, 0.69, 234.9, 366.69)"
  }, "R")), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(238.56 362.81) rotate(-42.79)"
  }, "R")), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(242.53 359.17) rotate(-40.27)"
  }, ".")), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(244.03 357.9) rotate(-38.92)"
  })), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "matrix(0.86, -0.51, 0.51, 0.86, 254.1, 350.72)"
  })), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "matrix(0.87, -0.49, 0.49, 0.87, 255.81, 349.72)"
  })), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(257.51 348.77) rotate(-27.68)"
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "matrix(0.9, -0.44, 0.44, 0.9, 259.26, 347.84)"
  })), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(261.02 346.97) rotate(-24.95)"
  })), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_220",
    transform: "translate(262.79 346.14) rotate(-23.59)"
  })), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(264.54 345.33) rotate(-21.03)"
  }, "A")), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(270.12 343.23) rotate(-18.22)"
  }, "i")), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(272.17 342.55) rotate(-16.37)"
  }, "r")), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(275.19 341.67) rotate(-14.36)"
  })), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(277.71 341) rotate(-11.63)"
  }, "T")), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(281.9 340.12) rotate(-8.78)"
  }, "e")), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(1, -0.08, 0.08, 1, 286.76, 339.32)"
  }, "m")), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(294.5 338.77) rotate(0.04)"
  }, "p")), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(1, 0.05, -0.05, 1, 299.97, 338.81)"
  })), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(302.59 338.93) rotate(4.97)"
  }, "\xB0")), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(306.29 339.21) rotate(8.54)"
  }, "C")), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(312.8 340.24) rotate(11.72)"
  })), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.97, 0.22, -0.22, 0.97, 314.41, 340.57)"
  })), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(365.32 374.45) rotate(56.04)"
  })), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.54, 0.84, -0.84, 0.54, 366.45, 376.11)"
  })), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.5, 0.87, -0.87, 0.5, 367.56, 377.78)"
  }, "A")), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(370.41 382.77) rotate(62.61)"
  }, "i")), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(371.31 384.51) rotate(64.31)"
  }, "r")), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.4, 0.91, -0.91, 0.4, 372.6, 387.18)"
  })), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(373.61 389.4) rotate(68.81)"
  }, "T")), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.32, 0.95, -0.95, 0.32, 375, 392.9)"
  }, "e")), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(376.47 397.06) rotate(75.37)"
  }, "m")), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.18, 0.98, -0.98, 0.18, 378.28, 404.09)"
  }, "p")), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(379.16 408.99) rotate(82.04)"
  })), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.11, 0.99, -0.99, 0.11, 379.46, 411.08)"
  }, "\xB0")), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(379.86 414.25) rotate(87.04)"
  }, "C")), _text128 || (_text128 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(380.13 420.37) rotate(89.83)"
  })), _text129 || (_text129 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(379.26 433.98) rotate(99.21)"
  })), _text130 || (_text130 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(378.93 436.09) rotate(100.69)"
  })), _text131 || (_text131 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(378.54 438.19) rotate(102.17)"
  })), _text132 || (_text132 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(378.09 440.29) rotate(103.66)"
  })), _text133 || (_text133 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(377.58 442.38) rotate(105.16)"
  })), _text134 || (_text134 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.29, 0.96, -0.96, -0.29, 377.03, 444.45)"
  })), _text135 || (_text135 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(376.42 446.49) rotate(108.13)"
  })), _text136 || (_text136 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(375.76 448.52) rotate(109.61)"
  })), _text137 || (_text137 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(375.05 450.55) rotate(111.1)"
  })), _text138 || (_text138 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(374.28 452.55) rotate(112.6)"
  })), _text139 || (_text139 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(373.46 454.54) rotate(114.08)"
  })), _text140 || (_text140 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(372.59 456.49) rotate(115.56)"
  })), _text141 || (_text141 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.45, 0.89, -0.89, -0.45, 371.67, 458.42)"
  })), _text142 || (_text142 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(370.7 460.32) rotate(118.52)"
  })), _text143 || (_text143 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.5, 0.87, -0.87, -0.5, 369.68, 462.23)"
  })), _text144 || (_text144 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(368.61 464.07) rotate(121.48)"
  })), _text145 || (_text145 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(367.49 465.91) rotate(122.96)"
  })), _text146 || (_text146 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(366.34 467.7) rotate(124.43)"
  })), _text147 || (_text147 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(365.13 469.48) rotate(125.9)"
  })), _text148 || (_text148 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(363.89 471.2) rotate(127.36)"
  })), _text149 || (_text149 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(362.58 472.91) rotate(128.84)"
  })), _text150 || (_text150 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.65, 0.76, -0.76, -0.65, 361.24, 474.59)"
  })), _text151 || (_text151 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(359.85 476.23) rotate(131.79)"
  })), _text152 || (_text152 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.69, 0.73, -0.73, -0.69, 358.45, 477.81)"
  })), _text153 || (_text153 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.7, 0.71, -0.71, -0.7, 356.98, 479.38)"
  })), _text154 || (_text154 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.72, 0.69, -0.69, -0.72, 355.47, 480.91)"
  })), _text155 || (_text155 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(353.92 482.4) rotate(137.66)"
  })), _text156 || (_text156 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(352.36 483.85) rotate(139.5)"
  }, "\xB0")), _text157 || (_text157 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(-0.8, 0.61, -0.61, -0.8, 349.96, 485.96)"
  }, "C")), _text158 || (_text158 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(244.41 380.73) rotate(-51.12)"
  }, "P")), _text159 || (_text159 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(247.42 377.04) rotate(-47.77)"
  }, "r")), _text160 || (_text160 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(249.36 374.88) rotate(-44.59)"
  }, "e")), _text161 || (_text161 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(252.49 371.8) rotate(-40.91)"
  }, "s")), _text162 || (_text162 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(255.54 369.15) rotate(-37.38)"
  }, "s")), _text163 || (_text163 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(258.76 366.71) rotate(-34.56)"
  })), _text164 || (_text164 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.85, -0.53, 0.53, 0.85, 260.38, 365.55)"
  }, "A")), _text165 || (_text165 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.88, -0.48, 0.48, 0.88, 264.63, 362.97)"
  }, "l")), _text166 || (_text166 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.89, -0.45, 0.45, 0.89, 266.41, 362)"
  }, "t")), _text167 || (_text167 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(268.73 360.84) rotate(-24.36)"
  })), _text168 || (_text168 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.93, -0.36, 0.36, 0.93, 271.41, 359.61)"
  }, "x")), _text169 || (_text169 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(275.73 358) rotate(-17.67)"
  })), _text170 || (_text170 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(278.54 357.08) rotate(-13.99)"
  }, "1")), _text171 || (_text171 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(283.61 355.84) rotate(-9.38)"
  }, "0")), _text172 || (_text172 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(288.75 355) rotate(-4.81)"
  }, "0")), _text173 || (_text173 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(1, 0, 0, 1, 293.95, 354.58)"
  }, "0")), _text174 || (_text174 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(1, 0.06, -0.06, 1, 299.21, 354.61)"
  }, "f")), _text175 || (_text175 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(302.27 354.79) rotate(5.99)"
  }, "t")), _text176 || (_text176 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(305.32 355.13) rotate(8.6)"
  })), _text177 || (_text177 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.98, 0.19, -0.19, 0.98, 308.15, 355.57)"
  })), _text178 || (_text178 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_217",
    transform: "translate(310.99 356.14) rotate(13.49)"
  })), _text179 || (_text179 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(331.44 364.59) rotate(33.33)"
  })), _text180 || (_text180 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.24, 0.97, -0.97, 0.24, 359.64, 402.82)"
  })), _text181 || (_text181 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(360.32 405.6) rotate(78.6)"
  })), _text182 || (_text182 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(360.88 408.44) rotate(81.14)"
  })), _text183 || (_text183 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(361.31 411.29) rotate(83.67)"
  })), _text184 || (_text184 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(361.62 414.16) rotate(86.19)"
  })), _text185 || (_text185 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(0.04, 1, -1, 0.04, 361.78, 417.01)"
  })), _text186 || (_text186 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "matrix(-0.02, 1, -1, -0.02, 361.86, 419.9)"
  })), _text187 || (_text187 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(361.79 422.78) rotate(93.66)"
  })), _text188 || (_text188 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(361.59 425.66) rotate(96.19)"
  })), _text189 || (_text189 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.18, 0.98, -0.98, -0.18, 361.33, 428.48)"
  }, "A")), _text190 || (_text190 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(360.35 433.76) rotate(103.39)"
  }, "I")), _text191 || (_text191 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(359.99 435.57) rotate(106.73)"
  }, "R")), _text192 || (_text192 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(358.31 441.02) rotate(110.16)"
  })), _text193 || (_text193 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.37, 0.93, -0.93, -0.37, 357.6, 442.95)"
  })), _text194 || (_text194 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(356.89 444.88) rotate(115.26)"
  }, "S")), _text195 || (_text195 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(354.64 449.7) rotate(119.94)"
  }, "P")), _text196 || (_text196 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "matrix(-0.57, 0.82, -0.82, -0.57, 352, 454.32)"
  }, "E")), _text197 || (_text197 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(349.18 458.44) rotate(128.84)"
  }, "E")), _text198 || (_text198 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_210",
    transform: "translate(346.09 462.35) rotate(133.56)"
  }, "D")), _text199 || (_text199 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.82, 0.57, -0.57, 0.82, 352.4, 338.15)"
  }, "M")), _text200 || (_text200 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.79, 0.62, -0.62, 0.79, 357.93, 342.04)"
  }, "a")), _text201 || (_text201 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 361.18, 344.58)"
  }, "c")), _text202 || (_text202 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.73, 0.68, -0.68, 0.73, 364.3, 347.25)"
  }, "h")), _text203 || (_text203 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.71, 0.71, -0.71, 0.71, 367.41, 350.19)"
  })), _text204 || (_text204 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(368.86 351.59) rotate(47.4)"
  }, "N")), _text205 || (_text205 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.64, 0.77, -0.77, 0.64, 372.64, 355.71)"
  }, "o")), _text206 || (_text206 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(375.43 359.12) rotate(52.4)"
  })), _text207 || (_text207 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.58, 0.81, -0.81, 0.58, 376.7, 360.73)"
  }, "o")), _text208 || (_text208 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.55, 0.83, -0.83, 0.55, 379.26, 364.33)"
  }, "r")), _text209 || (_text209 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(380.63 366.4) rotate(57.86)"
  })), _text210 || (_text210 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.5, 0.87, -0.87, 0.5, 381.76, 368.13)"
  }, "P")), _text211 || (_text211 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.46, 0.89, -0.89, 0.46, 384.23, 372.46)"
  }, "r")), _text212 || (_text212 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.43, 0.9, -0.9, 0.43, 385.34, 374.53)"
  }, "e")), _text213 || (_text213 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.4, 0.92, -0.92, 0.4, 387.13, 378.23)"
  }, "s")), _text214 || (_text214 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(388.65 381.75) rotate(69.04)"
  }, "s")), _text215 || (_text215 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.33, 0.94, -0.94, 0.33, 389.99, 385.3)"
  })), _text216 || (_text216 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "matrix(0.29, 0.96, -0.96, 0.29, 390.7, 387.23)"
  }, "A")), _text217 || (_text217 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(392.14 392.02) rotate(75.03)"
  }, "l")), _text218 || (_text218 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(392.56 393.6) rotate(76.26)"
  }, "t")), _text219 || (_text219 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(393.13 395.85) rotate(78.19)"
  }, "x")), _text220 || (_text220 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(393.93 399.74) rotate(80.04)"
  })), _text221 || (_text221 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(394.31 401.77) rotate(81.98)"
  }, "1")), _text222 || (_text222 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(394.91 405.99) rotate(84.56)"
  }, "0")), _text223 || (_text223 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(395.32 410.23) rotate(87.14)"
  }, "0")), _text224 || (_text224 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(395.54 414.48) rotate(89.76)"
  }, "0")), _text225 || (_text225 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(395.54 418.74) rotate(91.62)"
  }, "f")), _text226 || (_text226 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_218",
    transform: "translate(395.48 420.95) rotate(93)"
  }, "t")), _text227 || (_text227 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(400.32 373.95) rotate(68.01)"
  }, "A")), _text228 || (_text228 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(402.42 379.22) rotate(69.91)"
  }, "i")), _text229 || (_text229 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.32, 0.95, -0.95, 0.32, 403.06, 380.95)"
  }, "r")), _text230 || (_text230 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(403.98 383.63) rotate(72.4)"
  })), _text231 || (_text231 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(404.71 385.86) rotate(74.26)"
  }, "T")), _text232 || (_text232 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(405.81 389.7) rotate(76.2)"
  }, "e")), _text233 || (_text233 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(406.96 394.19) rotate(79.25)"
  }, "m")), _text234 || (_text234 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.13, 0.99, -0.99, 0.13, 408.32, 401.52)"
  }, "p")), _text235 || (_text235 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.1, 1, -1, 0.1, 408.99, 406.65)"
  })), _text236 || (_text236 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.07, 1, -1, 0.07, 409.23, 409)"
  }, "\xB0")), _text237 || (_text237 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(409.51 412.41) rotate(87.91)"
  }, "C")), _text238 || (_text238 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(409.69 418.73) rotate(90.26)"
  })), _text239 || (_text239 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(409.68 421.07) rotate(91.42)"
  })), _text240 || (_text240 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.05, 1, -1, -0.05, 409.64, 423.41)"
  }, "+")), _text241 || (_text241 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(409.43 427.46) rotate(94.95)"
  }, "5")), _text242 || (_text242 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.12, 0.99, -0.99, -0.12, 409.1, 431.18)"
  }, "0")), _text243 || (_text243 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.14, 0.99, -0.99, -0.14, 408.65, 434.93)"
  })), _text244 || (_text244 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.22, 0.98, -0.98, -0.22, 407.16, 443.44)"
  })), _text245 || (_text245 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(406.76 445.21) rotate(103.51)"
  })), _text246 || (_text246 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(406.33 447.01) rotate(104.45)"
  })), _text247 || (_text247 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(405.88 448.78) rotate(105.37)"
  })), _text248 || (_text248 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.28, 0.96, -0.96, -0.28, 405.4, 450.54)"
  })), _text249 || (_text249 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.3, 0.96, -0.96, -0.3, 404.88, 452.3)"
  })), _text250 || (_text250 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(404.36 454.03) rotate(108.63)"
  }, "0")), _text251 || (_text251 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.34, 0.94, -0.94, -0.34, 403.15, 457.6)"
  })), _text252 || (_text252 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(402.52 459.31) rotate(110.96)"
  })), _text253 || (_text253 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(401.87 461.02) rotate(111.88)"
  })), _text254 || (_text254 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(401.18 462.73) rotate(112.81)"
  })), _text255 || (_text255 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.4, 0.92, -0.92, -0.4, 400.48, 464.41)"
  })), _text256 || (_text256 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.42, 0.91, -0.91, -0.42, 399.75, 466.08)"
  })), _text257 || (_text257 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(398.98 467.75) rotate(115.58)"
  })), _text258 || (_text258 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.45, 0.89, -0.89, -0.45, 398.19, 469.4)"
  })), _text259 || (_text259 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(397.38 471.03) rotate(117.61)"
  }, "-")), _text260 || (_text260 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(396.2 473.32) rotate(119.2)"
  }, "4")), _text261 || (_text261 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(394.36 476.61) rotate(121.09)"
  }, "0")), _text262 || (_text262 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(392.42 479.82) rotate(122.48)"
  })), _text263 || (_text263 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.55, 0.83, -0.83, -0.55, 393.94, 483.02)"
  }, "-")), _text264 || (_text264 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(392.47 485.25) rotate(125.18)"
  }, "5")), _text265 || (_text265 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(390.25 488.4) rotate(127.05)"
  }, "6")), _text266 || (_text266 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.62, 0.78, -0.78, -0.62, 387.93, 491.45)"
  }, ",")), _text267 || (_text267 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(386.76 492.95) rotate(129.84)"
  }, "5")), _text268 || (_text268 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.66, 0.75, -0.75, -0.66, 382.04, 493.9)"
  })), _text269 || (_text269 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "matrix(-0.67, 0.74, -0.74, -0.67, 380.84, 495.27)"
  }, "-")), _text270 || (_text270 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(379.11 497.19) rotate(133.91)"
  }, "8")), _text271 || (_text271 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(376.52 499.89) rotate(135.78)"
  }, "0")), _text272 || (_text272 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(373.82 502.5) rotate(137.17)"
  })), _text273 || (_text273 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(372.47 503.76) rotate(138.3)"
  }, "\xB0")), _text274 || (_text274 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_222",
    transform: "translate(370.51 505.53) rotate(140.18)"
  }, "C")), _text275 || (_text275 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(-0.97, -0.25, 0.25, -0.97, 290.36, 456.7)"
  }, "x")), _text276 || (_text276 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(-0.93, -0.36, 0.36, -0.93, 286.58, 455.74)"
  }, "1")), _text277 || (_text277 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(-0.88, -0.47, 0.47, -0.88, 282.33, 454.09)"
  }, "0")), _text278 || (_text278 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 278.32, 451.94)"
  }, "0")), _text279 || (_text279 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(-0.74, -0.67, 0.67, -0.74, 274.59, 449.3)"
  }, "0")), _text280 || (_text280 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(-0.68, -0.74, 0.74, -0.68, 271.22, 446.18)"
  }, "f")), _text281 || (_text281 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_221",
    transform: "translate(269.44 444.23) rotate(-128.25)"
  }, "t")), _text282 || (_text282 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(379.08 420.01) rotate(93.62)"
  }, "+")), _text283 || (_text283 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(378.85 423.73) rotate(95.83)"
  }, "5")), _text284 || (_text284 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(378.5 427.16) rotate(97.97)"
  }, "0")), _text285 || (_text285 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(378.01 430.58) rotate(99.57)"
  })), _text286 || (_text286 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.18, 0.98, -0.98, -0.18, 377.73, 432.25)"
  })), _text287 || (_text287 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(377.43 433.87) rotate(101.65)"
  })), _text288 || (_text288 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.22, 0.98, -0.98, -0.22, 377.09, 435.52)"
  })), _text289 || (_text289 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.24, 0.97, -0.97, -0.24, 376.72, 437.15)"
  })), _text290 || (_text290 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(376.33 438.78) rotate(104.8)"
  })), _text291 || (_text291 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.27, 0.96, -0.96, -0.27, 375.9, 440.39)"
  })), _text292 || (_text292 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(375.45 441.99) rotate(106.89)"
  })), _text293 || (_text293 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.32, 0.95, -0.95, -0.32, 374.97, 443.61)"
  }, "0")), _text294 || (_text294 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(373.87 446.86) rotate(110.09)"
  })), _text295 || (_text295 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(373.29 448.45) rotate(111.15)"
  })), _text296 || (_text296 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(372.7 449.99) rotate(112.18)"
  })), _text297 || (_text297 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(372.06 451.55) rotate(113.23)"
  })), _text298 || (_text298 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(371.4 453.09) rotate(114.28)"
  })), _text299 || (_text299 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(370.71 454.62) rotate(115.33)"
  })), _text300 || (_text300 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(370 456.13) rotate(116.59)"
  }, "-")), _text301 || (_text301 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(368.96 458.24) rotate(118.39)"
  }, "4")), _text302 || (_text302 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.51, 0.86, -0.86, -0.51, 367.32, 461.28)"
  }, "0")), _text303 || (_text303 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(365.55 464.26) rotate(122.12)"
  })), _text304 || (_text304 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(364.67 465.67) rotate(123.16)"
  })), _text305 || (_text305 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.56, 0.83, -0.83, -0.56, 363.76, 467.07)"
  })), _text306 || (_text306 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.58, 0.82, -0.82, -0.58, 362.8, 468.47)"
  })), _text307 || (_text307 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(361.84 469.83) rotate(126.27)"
  })), _text308 || (_text308 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(360.86 471.17) rotate(127.3)"
  })), _text309 || (_text309 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.62, 0.78, -0.78, -0.62, 359.83, 472.52)"
  })), _text310 || (_text310 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.64, 0.77, -0.77, -0.64, 358.81, 473.82)"
  }, "-")), _text311 || (_text311 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "matrix(-0.66, 0.75, -0.75, -0.66, 357.32, 475.65)"
  }, "8")), _text312 || (_text312 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_223",
    transform: "translate(355.03 478.25) rotate(133.52)"
  }, "0")), _text313 || (_text313 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.63, 0.78, -0.78, -0.63, 362.72, 460.91)",
    fontSize: 6.5,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue"
  }, "-56.5")), _text314 || (_text314 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_224",
    transform: "translate(215.55 365.8) rotate(-54.91)"
  }, "T")), _text315 || (_text315 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_224",
    transform: "translate(217.79 362.55) rotate(-52.5)"
  }, "A")), _text316 || (_text316 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_224",
    transform: "translate(221.08 358.25) rotate(-49.45)"
  }, "S")), _text317 || (_text317 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.68, -0.73, 0.73, 0.68, 224.64, 354.12)"
  }, "-")), _text318 || (_text318 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(226.96 351.6) rotate(-44.69)"
  }, "3")), _text319 || (_text319 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.74, -0.68, 0.68, 0.74, 230.49, 348.13)"
  })), _text320 || (_text320 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(232.26 346.45) rotate(-40.16)"
  }, "D")), _text321 || (_text321 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "translate(237.07 342.45) rotate(-37.76)"
  }, "I")), _text322 || (_text322 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_214",
    transform: "matrix(0.81, -0.58, 0.58, 0.81, 238.85, 341.02)"
  }, "V")), _text323 || (_text323 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_204",
    transform: "matrix(0.62, -0.78, 0.78, 0.62, 222.61, 369.93)"
  }, "100")), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_131",
    d: "M215.95 373.28l-7.27-4.15"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.53 366.39l-7.58.04 3.82 6.54 3.76-6.58z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_131",
    d: "M205.8 373.28l-2.1 4.58"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.72 375.27l.7 7.55 6.18-4.39-6.88-3.16z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_131",
    d: "M274.95 459.03l-4.69 8.56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267.62 472.43l.94-8.33 1.9 3.13 3.66-.09-6.5 5.29z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_225",
    d: "M346.95 341.05l13.46-22.14"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#840000",
    d: "M362.35 323.83l-2.67-3.72-4.54-.66 8.81-6.36-1.6 10.74z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_226",
    d: "M182.05 398l2.81.43s-11.05 53.69 24.94 95.7c37.33 43.58 84 42.67 84 42.67v2.5M282.49 537.86l.25-2.08M271.08 535.45l.41-2.05M259.85 531.92l.68-1.98M249.14 527.15l.93-1.88M232.95 517.89l3.32-4.17M227.37 513.72l1.32-1.63M222.15 509.4l1.38-1.58M217.04 504.63l1.41-1.54M238.47 522.59l1.65-2.55M208.67 495.82l1.62-1.33M205.42 491.86l1.7-1.23M202.11 487.7l1.74-1.16M199.29 483.44l1.76-1.13M211.11 500.49l2.48-2.16M195.49 479.49l2.85-1.68M194.43 475.22l1.89-.89M192.48 471.17l1.95-.77M190.83 467.58l1.97-.71M189.37 463.68l1.99-.66M186.9 459.95l3.17-.92M185.93 453.76l2.04-.48M186.86 456.9l2.01-.59M184.49 447.73l2.03-.51M185.16 450.74l2.04-.47M182.66 444.89l3.24-.62M182.56 438.68l2.09-.21M183.08 441.81l2.07-.33M181.91 433.19l2.08-.25M182.19 436.09l2.08-.21M180.54 430.57l3.29-.2M181.16 425.95l2.09-.01M181.36 428.27l2.09-.02M181.14 421.48l2.09.04M181.14 423.71h2.09M180.17 419l3.3.07M181.05 415l2.1.07M181.17 417.18l2.09.07M181.21 410.79l2.09.12M181.12 413.02l2.09.08M180.33 408.47l3.3.2M181.75 404.65l2.08.23M181.7 406.84l2.08.22M182.22 400.46l2.07.28M181.97 402.68l2.08.24M269.89 532.99l.74-3.05M252.78 526.73l1.18-2.91M241.94 521.13l1.63-2.69M229.22 512.57l1.39-1.9M224.23 508.53l1.54-1.7M219.88 504.63l1.61-1.71M215.44 500.28l1.77-1.64M211.11 495.6l2.48-2.02M208.89 493.02l1.88-1.44M206.53 490.15l1.88-1.44M204.48 487.53l1.88-1.44M202.57 484.67l1.95-1.33M200.67 481.53l2.31-1.48M199.38 479.57l2.02-1.23M198.15 477.5l2.02-1.22M196.88 475.18l2.08-1.14M195.84 473.21l2.09-1.09M194.78 470.93l2.71-1.32M193.23 467.65l2.16-.95M191.8 464.41l2.23-.8M190.71 461.46l2.21-.85M189.59 458.17l2.22-.8M188.64 454.87l2.86-.94M187.88 452.4l2.26-.66M187.2 450.07l2.31-.51M186.52 447.5l2.3-.57M186.05 445.15l2.3-.52M185.48 442.65l2.95-.63M184.56 437.58l2.34-.34M183.98 432.58l3-.24M183.43 414.69l2.36-.02M183.43 411.61l2.36-.06M183.56 409.28l2.36.06M183.78 407.24l2.37.03M184.3 402.51l2.99.37M183.48 428.18l2.36-.12M183.43 424.19l2.36-.04M183.32 420.81l2.36-.02M183.32 417.48l2.36-.01M184.05 404.8l2.36.19"
  })), _text324 || (_text324 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(308.42 529.91) rotate(177.99)"
  })), _text325 || (_text325 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-1, 0.02, -0.02, -1, 307.01, 529.96)"
  })), _text326 || (_text326 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(305.58 529.99) rotate(179.43)"
  })), _text327 || (_text327 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-1, -0.01, 0.01, -1, 304.15, 530.01)"
  }, "\xB0")), _text328 || (_text328 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(301.78 530) rotate(-178.23)"
  }, "C")), _text329 || (_text329 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(298.68 529.89) rotate(-177.09)"
  })), _text330 || (_text330 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(297.24 529.82) rotate(-176.36)"
  })), _text331 || (_text331 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-1, -0.08, 0.08, -1, 295.83, 529.73)"
  })), _text332 || (_text332 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-1, -0.09, 0.09, -1, 294.41, 529.62)"
  })), _text333 || (_text333 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(292.98 529.5) rotate(-174.2)"
  })), _text334 || (_text334 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(291.56 529.35) rotate(-173.48)"
  })), _text335 || (_text335 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.99, -0.13, 0.13, -0.99, 290.15, 529.19)"
  })), _text336 || (_text336 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.99, -0.14, 0.14, -0.99, 288.73, 529.01)"
  })), _text337 || (_text337 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.99, -0.15, 0.15, -0.99, 287.32, 528.81)"
  })), _text338 || (_text338 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(285.91 528.6) rotate(-170.6)"
  })), _text339 || (_text339 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.98, -0.18, 0.18, -0.98, 284.5, 528.36)"
  })), _text340 || (_text340 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(283.1 528.11) rotate(-169.16)"
  })), _text341 || (_text341 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(281.7 527.84) rotate(-168.44)"
  })), _text342 || (_text342 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(280.28 527.56) rotate(-167.71)"
  })), _text343 || (_text343 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(278.89 527.25) rotate(-166.99)"
  })), _text344 || (_text344 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.97, -0.24, 0.24, -0.97, 277.51, 526.93)"
  })), _text345 || (_text345 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(276.11 526.59) rotate(-165.54)"
  })), _text346 || (_text346 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(274.74 526.24) rotate(-164.82)"
  })), _text347 || (_text347 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(273.37 525.87) rotate(-163.75)"
  }, "2")), _text348 || (_text348 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.95, -0.3, 0.3, -0.95, 270.62, 525.06)"
  })), _text349 || (_text349 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(269.25 524.64) rotate(-161.93)"
  })), _text350 || (_text350 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(267.9 524.2) rotate(-161.22)"
  })), _text351 || (_text351 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(266.56 523.74) rotate(-160.5)"
  })), _text352 || (_text352 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(265.21 523.26) rotate(-159.78)"
  })), _text353 || (_text353 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.93, -0.36, 0.36, -0.93, 263.87, 522.77)"
  })), _text354 || (_text354 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(262.54 522.26) rotate(-158.33)"
  })), _text355 || (_text355 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(261.21 521.73) rotate(-157.6)"
  })), _text356 || (_text356 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(259.89 521.19) rotate(-156.88)"
  })), _text357 || (_text357 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(258.57 520.62) rotate(-156.15)"
  })), _text358 || (_text358 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(257.27 520.06) rotate(-155.07)"
  }, "3")), _text359 || (_text359 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.9, -0.44, 0.44, -0.9, 254.68, 518.84)"
  })), _text360 || (_text360 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(253.39 518.22) rotate(-153.25)"
  })), _text361 || (_text361 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(252.12 517.58) rotate(-152.53)"
  })), _text362 || (_text362 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(250.85 516.92) rotate(-151.8)"
  })), _text363 || (_text363 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.88, -0.48, 0.48, -0.88, 249.6, 516.24)"
  })), _text364 || (_text364 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(248.35 515.55) rotate(-150.35)"
  })), _text365 || (_text365 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(247.12 514.86) rotate(-149.26)"
  }, "4")), _text366 || (_text366 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(244.66 513.39) rotate(-148.17)"
  })), _text367 || (_text367 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.84, -0.54, 0.54, -0.84, 243.2, 512.49)"
  })), _text368 || (_text368 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.83, -0.55, 0.55, -0.83, 241.79, 511.58)"
  })), _text369 || (_text369 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(240.38 510.65) rotate(-145.19)"
  }, "5")), _text370 || (_text370 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(238.04 509.01) rotate(-144.1)"
  })), _text371 || (_text371 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.8, -0.6, 0.6, -0.8, 236.87, 508.16)"
  })), _text372 || (_text372 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(235.73 507.31) rotate(-142.62)"
  })), _text373 || (_text373 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.79, -0.62, 0.62, -0.79, 234.59, 506.45)"
  })), _text374 || (_text374 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.78, -0.63, 0.63, -0.78, 233.47, 505.57)"
  })), _text375 || (_text375 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.77, -0.64, 0.64, -0.77, 232.36, 504.67)"
  })), _text376 || (_text376 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(231.26 503.76) rotate(-139.67)"
  })), _text377 || (_text377 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.75, -0.66, 0.66, -0.75, 230.17, 502.84)"
  })), _text378 || (_text378 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(229.1 501.9) rotate(-138.19)"
  })), _text379 || (_text379 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(228.03 500.95) rotate(-137.45)"
  })), _text380 || (_text380 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.73, -0.69, 0.69, -0.73, 226.98, 499.99)"
  })), _text381 || (_text381 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(225.95 499.02) rotate(-135.97)"
  })), _text382 || (_text382 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(224.92 498.02) rotate(-135.23)"
  })), _text383 || (_text383 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(223.91 497.02) rotate(-134.48)"
  })), _text384 || (_text384 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(222.92 496.01) rotate(-133.75)"
  })), _text385 || (_text385 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(221.93 494.98) rotate(-133)"
  })), _text386 || (_text386 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(220.95 493.93) rotate(-132.25)"
  })), _text387 || (_text387 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.66, -0.75, 0.75, -0.66, 219.98, 492.87)"
  }, "1")), _text388 || (_text388 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.64, -0.77, 0.77, -0.64, 218.12, 490.74)"
  }, "0")), _text389 || (_text389 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(216.29 488.51) rotate(-128.49)"
  })), _text390 || (_text390 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(215.42 487.42) rotate(-127.76)"
  })), _text391 || (_text391 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.6, -0.8, 0.8, -0.6, 214.53, 486.28)"
  })), _text392 || (_text392 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.59, -0.81, 0.81, -0.59, 213.67, 485.14)"
  })), _text393 || (_text393 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.58, -0.81, 0.81, -0.58, 212.83, 483.99)"
  })), _text394 || (_text394 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.57, -0.82, 0.82, -0.57, 212, 482.83)"
  })), _text395 || (_text395 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(211.19 481.65) rotate(-123.99)"
  })), _text396 || (_text396 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(210.39 480.46) rotate(-123.23)"
  })), _text397 || (_text397 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.54, -0.84, 0.84, -0.54, 209.6, 479.27)"
  })), _text398 || (_text398 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(208.84 478.07) rotate(-121.72)"
  })), _text399 || (_text399 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.51, -0.86, 0.86, -0.51, 208.1, 476.87)"
  })), _text400 || (_text400 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(207.36 475.63) rotate(-120.21)"
  })), _text401 || (_text401 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.49, -0.87, 0.87, -0.49, 206.64, 474.41)"
  })), _text402 || (_text402 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.48, -0.88, 0.88, -0.48, 205.93, 473.15)"
  })), _text403 || (_text403 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.47, -0.88, 0.88, -0.47, 205.25, 471.9)"
  })), _text404 || (_text404 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.46, -0.89, 0.89, -0.46, 204.58, 470.64)"
  })), _text405 || (_text405 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(203.93 469.39) rotate(-116.07)"
  }, "2")), _text406 || (_text406 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.42, -0.91, 0.91, -0.42, 202.67, 466.83)"
  }, "0")), _text407 || (_text407 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(201.49 464.22) rotate(-113.44)"
  })), _text408 || (_text408 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(200.92 462.91) rotate(-112.69)"
  })), _text409 || (_text409 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(200.37 461.6) rotate(-111.95)"
  })), _text410 || (_text410 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(199.84 460.27) rotate(-111.2)"
  })), _text411 || (_text411 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(199.32 458.95) rotate(-110.46)"
  })), _text412 || (_text412 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(198.82 457.6) rotate(-109.71)"
  })), _text413 || (_text413 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.33, -0.95, 0.95, -0.33, 198.34, 456.27)"
  })), _text414 || (_text414 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(197.88 454.93) rotate(-107.86)"
  }, "3")), _text415 || (_text415 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(196.99 452.23) rotate(-105.8)"
  }, "0")), _text416 || (_text416 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(196.19 449.45) rotate(-105.28)"
  })), _text417 || (_text417 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(195.82 448.08) rotate(-104.54)"
  })), _text418 || (_text418 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(195.46 446.7) rotate(-103.8)"
  })), _text419 || (_text419 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(195.12 445.3) rotate(-103.05)"
  })), _text420 || (_text420 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(194.8 443.94) rotate(-101.94)"
  }, "4")), _text421 || (_text421 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(194.2 441.15) rotate(-100.45)"
  }, "0")), _text422 || (_text422 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(193.69 438.33) rotate(-99.32)"
  })), _text423 || (_text423 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.15, -0.99, 0.99, -0.15, 193.46, 436.91)"
  })), _text424 || (_text424 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(193.25 435.51) rotate(-97.82)"
  })), _text425 || (_text425 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.12, -0.99, 0.99, -0.12, 193.05, 434.09)"
  }, "5")), _text426 || (_text426 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.09, -1, 1, -0.09, 192.71, 431.25)"
  }, "0")), _text427 || (_text427 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.46 428.43) rotate(-94.06)"
  })), _text428 || (_text428 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.36 426.99) rotate(-93.29)"
  })), _text429 || (_text429 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.04, -1, 1, -0.04, 192.28, 425.55)"
  })), _text430 || (_text430 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.22 424.14) rotate(-91.79)"
  })), _text431 || (_text431 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.17 422.72) rotate(-91.04)"
  })), _text432 || (_text432 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(0, -1, 1, 0, 192.15, 421.29)"
  })), _text433 || (_text433 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.14 419.86) rotate(-89.52)"
  })), _text434 || (_text434 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(0.02, -1, 1, 0.02, 192.15, 418.43)"
  })), _text435 || (_text435 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.18 417) rotate(-88.02)"
  })), _text436 || (_text436 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.23 415.58) rotate(-87.27)"
  })), _text437 || (_text437 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.3 414.16) rotate(-86.51)"
  })), _text438 || (_text438 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(0.07, -1, 1, 0.07, 192.38, 412.74)"
  })), _text439 || (_text439 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.49 411.32) rotate(-85.02)"
  })), _text440 || (_text440 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.61 409.89) rotate(-84.26)"
  })), _text441 || (_text441 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.75 408.47) rotate(-83.13)"
  }, "1")), _text442 || (_text442 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(0.15, -0.99, 0.99, 0.15, 193.09, 405.64)"
  }, "0")), _text443 || (_text443 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(193.51 402.8) rotate(-80.14)"
  }, "0")), _text444 || (_text444 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(194 400) rotate(-79.03)"
  })), _text445 || (_text445 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(307.49 541.64) rotate(176.67) scale(1.01 1)"
  }, "K")), _text446 || (_text446 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(304.47 541.81) rotate(177.79) scale(1.01 1)"
  }, "t")), _text447 || (_text447 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(302.92 541.87) rotate(178.77) scale(1.01 1)"
  }, "s")), _text448 || (_text448 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(300.49 541.92) rotate(179.72) scale(1.01 1)"
  })), _text449 || (_text449 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(299.06 541.94) rotate(-179.22) scale(1.01 1)"
  }, "1")), _text450 || (_text450 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(296.18 541.9) rotate(-177.81) scale(1.01 1)"
  }, "0")), _text451 || (_text451 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(293.32 541.79) rotate(-176.4) scale(1.01 1)"
  }, "0")), _text452 || (_text452 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(290.44 541.6) rotate(-175.33) scale(1.01 1)"
  })), _text453 || (_text453 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(289.23 541.51) rotate(-174.41) scale(1.01 1)"
  }, "T")), _text454 || (_text454 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(286.8 541.28) rotate(-173.15) scale(1.01 1)"
  }, "A")), _text455 || (_text455 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(283.81 540.92) rotate(-171.68) scale(1.01 1)"
  }, "S")), _text456 || (_text456 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(280.87 540.48) rotate(-170.6) scale(1.01 1)"
  })), _text457 || (_text457 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.97, -0.27, 0.27, -0.96, 268.91, 537.93)"
  })), _text458 || (_text458 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(267.51 537.55) rotate(-163.92) scale(1.01 1)"
  })), _text459 || (_text459 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.96, -0.29, 0.29, -0.96, 266.12, 537.15)"
  })), _text460 || (_text460 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.96, -0.3, 0.3, -0.95, 264.76, 536.73)"
  })), _text461 || (_text461 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.96, -0.31, 0.31, -0.95, 263.4, 536.31)"
  })), _text462 || (_text462 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.95, -0.33, 0.32, -0.95, 262.03, 535.86)"
  })), _text463 || (_text463 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.95, -0.34, 0.33, -0.94, 260.66, 535.39)"
  })), _text464 || (_text464 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.94, -0.35, 0.35, -0.94, 259.32, 534.91)"
  })), _text465 || (_text465 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(257.95 534.4) rotate(-159.03) scale(1.01 1)"
  })), _text466 || (_text466 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(256.62 533.9) rotate(-158.34) scale(1.01 1)"
  })), _text467 || (_text467 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(255.28 533.36) rotate(-157.65) scale(1.01 1)"
  })), _text468 || (_text468 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(253.94 532.81) rotate(-156.95) scale(1.01 1)"
  })), _text469 || (_text469 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.92, -0.41, 0.4, -0.92, 252.63, 532.26)"
  })), _text470 || (_text470 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.92, -0.42, 0.41, -0.91, 251.31, 531.68)"
  })), _text471 || (_text471 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(249.99 531.08) rotate(-154.87) scale(1.01 1)"
  })), _text472 || (_text472 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.91, -0.44, 0.44, -0.9, 248.71, 530.47)"
  })), _text473 || (_text473 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(247.4 529.84) rotate(-153.5) scale(1.01 1)"
  })), _text474 || (_text474 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.9, -0.46, 0.46, -0.89, 246.11, 529.2)"
  })), _text475 || (_text475 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(244.84 528.55) rotate(-152.12) scale(1.01 1)"
  })), _text476 || (_text476 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.88, -0.48, 0.48, -0.88, 243.57, 527.87)"
  })), _text477 || (_text477 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(242.3 527.18) rotate(-150.74) scale(1.01 1)"
  })), _text478 || (_text478 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(241.04 526.49) rotate(-149.71) scale(1.01 1)"
  }, "2")), _text479 || (_text479 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.86, -0.53, 0.52, -0.85, 238.58, 525.05)"
  }, "0")), _text480 || (_text480 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(236.11 523.53) rotate(-146.97) scale(1.01 1)"
  }, "0")), _text481 || (_text481 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.83, -0.56, 0.56, -0.83, 233.71, 521.96)"
  })), _text482 || (_text482 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(232.51 521.15) rotate(-145.26) scale(1.01 1)"
  })), _text483 || (_text483 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.82, -0.58, 0.58, -0.81, 231.34, 520.33)"
  })), _text484 || (_text484 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(230.17 519.5) rotate(-143.9) scale(1.01 1)"
  })), _text485 || (_text485 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.81, -0.6, 0.6, -0.8, 229.01, 518.66)"
  })), _text486 || (_text486 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(227.85 517.79) rotate(-142.54) scale(1.01 1)"
  })), _text487 || (_text487 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(226.71 516.92) rotate(-141.86) scale(1.01 1)"
  })), _text488 || (_text488 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.78, -0.63, 0.63, -0.78, 225.58, 516.03)"
  })), _text489 || (_text489 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.78, -0.64, 0.64, -0.77, 224.47, 515.13)"
  })), _text490 || (_text490 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(223.36 514.22) rotate(-139.82) scale(1.01 1)"
  })), _text491 || (_text491 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(222.26 513.29) rotate(-139.14) scale(1.01 1)"
  })), _text492 || (_text492 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.75, -0.67, 0.66, -0.75, 221.17, 512.35)"
  })), _text493 || (_text493 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(220.09 511.4) rotate(-137.79) scale(1.01 1)"
  })), _text494 || (_text494 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.74, -0.69, 0.68, -0.73, 219.02, 510.43)"
  })), _text495 || (_text495 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(217.97 509.45) rotate(-136.43) scale(1.01 1)"
  })), _text496 || (_text496 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.72, -0.7, 0.7, -0.72, 216.94, 508.47)"
  })), _text497 || (_text497 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.71, -0.71, 0.71, -0.71, 215.9, 507.46)"
  })), _text498 || (_text498 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(214.88 506.44) rotate(-134.41) scale(1.01 1)"
  })), _text499 || (_text499 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(213.88 505.42) rotate(-133.74) scale(1.01 1)"
  })), _text500 || (_text500 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.68, -0.74, 0.73, -0.68, 212.87, 504.37)"
  }, "3")), _text501 || (_text501 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.67, -0.76, 0.75, -0.66, 210.93, 502.27)"
  }, "0")), _text502 || (_text502 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.65, -0.77, 0.77, -0.64, 209.03, 500.12)"
  }, "0")), _text503 || (_text503 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(207.18 497.9) rotate(-129.03) scale(1.01 1)"
  })), _text504 || (_text504 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(206.27 496.78) rotate(-128.36) scale(1.01 1)"
  })), _text505 || (_text505 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.62, -0.8, 0.79, -0.61, 205.38, 495.65)"
  })), _text506 || (_text506 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(204.51 494.53) rotate(-127.02) scale(1.01 1)"
  })), _text507 || (_text507 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.6, -0.81, 0.81, -0.59, 203.64, 493.37)"
  })), _text508 || (_text508 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.59, -0.82, 0.81, -0.58, 202.78, 492.21)"
  })), _text509 || (_text509 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(201.95 491.05) rotate(-125.02) scale(1.01 1)"
  })), _text510 || (_text510 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(201.12 489.87) rotate(-124.36) scale(1.01 1)"
  })), _text511 || (_text511 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(200.3 488.67) rotate(-123.69) scale(1.01 1)"
  })), _text512 || (_text512 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(199.51 487.48) rotate(-123.02) scale(1.01 1)"
  })), _text513 || (_text513 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.54, -0.85, 0.84, -0.54, 198.72, 486.28)"
  })), _text514 || (_text514 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.53, -0.86, 0.85, -0.53, 197.95, 485.06)"
  })), _text515 || (_text515 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(197.2 483.86) rotate(-120.71) scale(1.01 1)"
  }, "4")), _text516 || (_text516 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.49, -0.88, 0.87, -0.49, 195.73, 481.37)"
  }, "0")), _text517 || (_text517 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(194.32 478.88) rotate(-118.08) scale(1.01 1)"
  }, "0")), _text518 || (_text518 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(192.97 476.33) rotate(-117.09) scale(1.01 1)"
  })), _text519 || (_text519 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.45, -0.9, 0.9, -0.45, 192.31, 475.04)"
  })), _text520 || (_text520 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(191.67 473.75) rotate(-115.79) scale(1.01 1)"
  })), _text521 || (_text521 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.43, -0.91, 0.91, -0.42, 191.04, 472.45)"
  })), _text522 || (_text522 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(190.44 471.17) rotate(-114.49) scale(1.01 1)"
  })), _text523 || (_text523 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(189.84 469.84) rotate(-113.84) scale(1.01 1)"
  })), _text524 || (_text524 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(189.26 468.54) rotate(-113.19) scale(1.01 1)"
  })), _text525 || (_text525 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(188.68 467.2) rotate(-112.54) scale(1.01 1)"
  })), _text526 || (_text526 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(188.13 465.87) rotate(-111.9) scale(1.01 1)"
  })), _text527 || (_text527 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(187.6 464.56) rotate(-110.94) scale(1.01 1)"
  }, "5")), _text528 || (_text528 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(186.56 461.85) rotate(-109.66) scale(1.01 1)"
  }, "0")), _text529 || (_text529 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(185.6 459.16) rotate(-108.39) scale(1.01 1)"
  }, "0")), _text530 || (_text530 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(184.69 456.41) rotate(-107.44) scale(1.01 1)"
  })), _text531 || (_text531 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(184.27 455.06) rotate(-106.84) scale(1.01 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.46,
    y: 0.01
  }))), _text532 || (_text532 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(183.44 452.28) rotate(-105.03) scale(1.01 1)"
  })), _text533 || (_text533 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.26, -0.97, 0.97, -0.26, 183.06, 450.91)"
  })), _text534 || (_text534 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.25, -0.98, 0.97, -0.25, 182.69, 449.52)"
  })), _text535 || (_text535 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.23, -0.98, 0.97, -0.23, 182.33, 448.12)"
  }, "6")), _text536 || (_text536 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(181.66 445.32) rotate(-102.11) scale(1.01 1)"
  }, "0")), _text537 || (_text537 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(181.06 442.51) rotate(-100.85) scale(1.01 1)"
  }, "0")), _text538 || (_text538 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(180.52 439.68) rotate(-99.91) scale(1.01 1)"
  })), _text539 || (_text539 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(180.27 438.26) rotate(-99.27) scale(1.01 1)"
  })), _text540 || (_text540 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(180.04 436.83) rotate(-98.64) scale(1.01 1)"
  })), _text541 || (_text541 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(179.82 435.44) rotate(-97.7) scale(1.01 1)"
  }, "7")), _text542 || (_text542 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(179.44 432.57) rotate(-96.42) scale(1.01 1)"
  }, "0")), _text543 || (_text543 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.09, -1, 1, -0.09, 179.11, 429.7)"
  }, "0")), _text544 || (_text544 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.86 426.85) rotate(-94.21) scale(1.01 1)"
  })), _text545 || (_text545 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.75 425.4) rotate(-93.57) scale(1.01 1)"
  })), _text546 || (_text546 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.05, -1.01, 1, -0.05, 178.67, 423.98)"
  })), _text547 || (_text547 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(-0.04, -1.01, 1, -0.03, 178.59, 422.56)"
  }, "8")), _text548 || (_text548 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.49 419.67) rotate(-90.73) scale(1.01 1)"
  }, "0")), _text549 || (_text549 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.45 416.8) rotate(-89.46) scale(1.01 1)"
  }, "0")), _text550 || (_text550 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(0.03, -1.01, 1, 0.03, 178.48, 413.91)"
  })), _text551 || (_text551 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.51 412.48) rotate(-87.56) scale(1.01 1)"
  }, "9")), _text552 || (_text552 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.64 409.6) rotate(-86.3) scale(1.01 1)"
  }, "0")), _text553 || (_text553 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(178.82 406.73) rotate(-85.04) scale(1.01 1)"
  }, "0")), _text554 || (_text554 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(179.08 403.84) rotate(-84.08) scale(1.01 1)"
  })), _text555 || (_text555 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(179.22 402.43) rotate(-83.14) scale(1.01 1)"
  }, "1")), _text556 || (_text556 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "matrix(0.14, -1, 0.99, 0.14, 179.56, 399.56)"
  }, "0")), _text557 || (_text557 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(179.97 396.74) rotate(-80.63) scale(1.01 1)"
  }, "0")), _text558 || (_text558 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_230",
    transform: "translate(180.43 393.9) rotate(-79.37) scale(1.01 1)"
  }, "0")), _text559 || (_text559 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.62, -0.78, 0.78, -0.62, 229.63, 491.66)",
    letterSpacing: ".04em",
    fontSize: 6,
    fill: "#840000",
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue"
  }, "TEM", /*#__PURE__*/React.createElement("tspan", {
    x: 10.59,
    y: 0,
    letterSpacing: "-.08em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.97,
    y: 0,
    letterSpacing: ".01em"
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "crp5_231",
    x: 14.46,
    y: 0
  }, " RISE"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.71 409.42s9.66 32.67-22.67 47.34l8.17 19.66s21.41-5.5 32.41-30.75 2.5-42.5 2.5-42.5z",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    stroke: "#000",
    fill: "none"
  })), _text560 || (_text560 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(0.11, 0.99, -0.99, 0.11, 339.92, 413.28)"
  }, "M")), _text561 || (_text561 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(340.33 417.13) rotate(87.66)"
  }, "A")), _text562 || (_text562 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.02, 1, -1, -0.02, 340.44, 419.89)"
  }, "C")), _text563 || (_text563 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.08, 1, -1, -0.08, 340.4, 422.78)"
  }, "H")), _text564 || (_text564 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.12, 0.99, -0.99, -0.12, 340.15, 425.77)"
  })), _text565 || (_text565 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(340.01 427.12) rotate(99.59)"
  }, "N")), _text566 || (_text566 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.23, 0.97, -0.97, -0.23, 339.49, 430.13)"
  }, "o")), _text567 || (_text567 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(338.92 432.56) rotate(105.49)"
  }, ".")), _text568 || (_text568 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(338.61 433.68) rotate(107.01)"
  })), _text569 || (_text569 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(338.23 434.98) rotate(109.98)"
  }, "O")), _text570 || (_text570 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.41, 0.91, -0.91, -0.41, 337.18, 437.86)"
  }, "R")), _text571 || (_text571 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(335.98 440.5) rotate(117.02)"
  })), _text572 || (_text572 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(335.38 441.71) rotate(120.02)"
  }, "R")), _text573 || (_text573 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(333.93 444.19) rotate(123.01)"
  }, ".")), _text574 || (_text574 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(333.2 445.34) rotate(125.96)"
  }, "A")), _text575 || (_text575 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(331.56 447.57) rotate(128.87)"
  }, ".")), _text576 || (_text576 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(330.72 448.64) rotate(131.77)"
  }, "S")), _text577 || (_text577 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.7, 0.71, -0.71, -0.7, 328.85, 450.7)"
  }, ".")), _text578 || (_text578 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.73, 0.69, -0.69, -0.73, 327.9, 451.67)"
  }, "/")), _text579 || (_text579 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.76, 0.65, -0.65, -0.76, 326.77, 452.77)"
  }, "C")), _text580 || (_text580 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(324.55 454.63) rotate(142.19)"
  }, ".")), _text581 || (_text581 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(323.49 455.47) rotate(144.7)"
  }, "A")), _text582 || (_text582 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.84, 0.54, -0.54, -0.84, 321.2, 457.08)"
  }, ".")), _text583 || (_text583 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "translate(320.07 457.83) rotate(149.43)"
  }, "S")), _text584 || (_text584 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_232",
    transform: "matrix(-0.88, 0.48, -0.48, -0.88, 317.65, 459.24)"
  }, ".")), _text585 || (_text585 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(348.91 411.46) rotate(83) scale(0.93 1)"
  }, "T")), _text586 || (_text586 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(0.06, 0.93, -1, 0.06, 349.28, 414.4)"
  }, "O")), _text587 || (_text587 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(0.02, 0.93, -1, 0.02, 349.49, 418.34)"
  })), _text588 || (_text588 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(349.54 419.79) rotate(91.32) scale(0.93 1)"
  }, "C")), _text589 || (_text589 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.08, 0.93, -1, -0.08, 349.46, 423.53)"
  }, "O")), _text590 || (_text590 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.14, 0.92, -0.99, -0.15, 349.14, 427.41)"
  }, "M")), _text591 || (_text591 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(348.45 431.84) rotate(102.47) scale(0.93 1)"
  }, "P")), _text592 || (_text592 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.26, 0.9, -0.96, -0.28, 347.73, 435.1)"
  }, "U")), _text593 || (_text593 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.31, 0.88, -0.94, -0.34, 346.69, 438.69)"
  }, "T")), _text594 || (_text594 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.36, 0.86, -0.92, -0.39, 345.7, 441.47)"
  }, "E")), _text595 || (_text595 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(344.44 444.4) rotate(115.59) scale(0.93 1)"
  })), _text596 || (_text596 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.44, 0.82, -0.88, -0.47, 343.82, 445.72)"
  }, "T")), _text597 || (_text597 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(342.68 447.85) rotate(120.06) scale(0.93 1)"
  }, ".")), _text598 || (_text598 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.51, 0.78, -0.84, -0.54, 341.98, 449.1)"
  }, "A")), _text599 || (_text599 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.54, 0.76, -0.81, -0.58, 340.13, 451.92)"
  }, ".")), _text600 || (_text600 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(339.3 453.11) rotate(128.53) scale(0.93 1)"
  }, "S")), _text601 || (_text601 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(337.21 455.71) rotate(131.33) scale(0.93 1)"
  }, ".")), _text602 || (_text602 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.64, 0.68, -0.73, -0.68, 336.22, 456.82)"
  })), _text603 || (_text603 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(335.24 457.9) rotate(135.6) scale(0.93 1)"
  }, "F")), _text604 || (_text604 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "matrix(-0.71, 0.61, -0.65, -0.76, 333.12, 459.98)"
  }, "R")), _text605 || (_text605 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(330.46 462.29) rotate(143.24) scale(0.93 1)"
  }, "O")), _text606 || (_text606 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_233",
    transform: "translate(327.34 464.62) rotate(147.5) scale(0.93 1)"
  }, "M")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5FrontDisk);
export default __webpack_public_path__ + "static/media/crp5-front-disk.46b39fc09f41dab080f6d01d45694c03.svg";
export { ForwardRef as ReactComponent };